export const REQUEST_QUIZ='REQUEST_QUIZ'
export const RECEIVED_QUIZ='RECEIVED_QUIZ'
export const NOTRECEIVED_QUIZ='NOTRECEIVED_QUIZ'

export const RESET_QUIZ='RESET_QUIZ'
export const SETUP_QUIZ='SETUP_QUIZ'
export const SELECT_NEXT='SELECT_NEXT'
export const SELECT_BEFORE='SELECT_BEFORE'

export const GET_QUESTIONRESULT='GET_QUESTIONRESULT'
export const GET_QUIZRESULT='GET_QUIZRESULT'

export const SELECT_CHECK='SELECT_CHECK'
export const SELECT_CHOICE='SELECT_CHOICE'
export const PLAY_VIDEO='PLAY_VIDEO'
export const SHOW_VIDEO='SHOW_VIDEO'
export const HIDE_VIDEO='HIDE_VIDEO'
// Google analytics






// WEBPACK FOOTER //
// ./src/actions/ActionTypes.js